class ProductOption extends HTMLElement {
  abortController;

  /**
   * Connected callback.
   */
  connectedCallback() {
    this.querySelector('input').addEventListener('change', () => this.changeHandler());
  }

  /**
   * Disconnected callback.
   */
  disconnectedCallback() {
    this.querySelector('input').removeEventListener('change', this.changeHandler);
  }

  /**
   * Change handler, show/hide the option description.
   * @param {Event} event - The change event.
   */
  changeHandler = () => {
    const input = this.querySelector('input');
    const value = input.value;
    const checked = input.checked;

    this.closest('fieldset')
      ?.querySelectorAll('[data-option-description]')
      .forEach((optionDescription) => {
        const optionDescriptionValue = optionDescription.dataset.optionDescription;
        if (optionDescriptionValue === value) {
          optionDescription.classList.toggle('hidden', !checked);
        } else {
          optionDescription.classList.add('hidden');
        }
      });

    // Bundle/add-on selects update client-side only (no section re-render), so the
    // fieldset's "selected value" label needs updating here too, not just on load.
    if (!checked) return;
    const selectedValueEl = this.closest('fieldset')?.querySelector('[data-selected-value]');
    if (!selectedValueEl) return;
    const isNoneOption = input.dataset.noneOption === 'true';
    selectedValueEl.textContent = ` ${value}`;
    // Keep in sync with the server-rendered none_selected flag (see product-option-label.liquid)
    // so consumers like the selected options summary can reliably tell a "none" choice apart
    // from a real value, without relying on the textContent staying exactly "None".
    if (isNoneOption) {
      selectedValueEl.setAttribute('data-none-selected', 'true');
    } else {
      selectedValueEl.removeAttribute('data-none-selected');
    }
  };
}

customElements.define('product-option', ProductOption);
